<template>
    <b-modal
        v-model="shown"
        centered
        :title="title"
        lazy
    >
        <div>

            <!-- Name -->
            <b-form-group>
                <label>Name</label>
                <b-form-input v-model="$v.name.$model" />
                <b-form-invalid-feedback :force-show="$v.$dirty && !$v.name.required">
                    Please enter a tab name.
                </b-form-invalid-feedback>
            </b-form-group>
            <!--/ Name -->

            <!-- Description -->
            <b-form-group>
                <label>Description</label>
                <b-form-textarea v-model="description" />
            </b-form-group>
            <!--/ Description -->

        </div>
        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="close()"
            >
                Close
            </b-btn>
            <Button
                variant="success"
                :loading="submitLoading"
                :disabled="$v.$invalid"
                @click="handleSubmit()"
            >
                Save
            </Button>
        </div>
    </b-modal>
</template>

<script>
import required from 'vuelidate/lib/validators/required';
import vueComponentReset from '@ianwalter/vue-component-reset';

const resetMixin = vueComponentReset(() => ({
    shown: false,
    tabId: null,
    title: '',
    name: '',
    description: '',
    submitLoading: false,
}));

export default {

    mixins: [
        resetMixin,
    ],

    validations: {
        name: {
            required,
        },
    },

    created() {
        this.$eventBus.$on(this.$events.openDuplicateTabModal, (tab) => {
            this.$v.$reset();
            this.reset();
            this.tabId = tab.id;
            this.title = `Duplicate Tab - ${tab.name}`;
            this.name = tab.name;
            this.description = tab.description;
            this.open();
        });
    },

    methods: {
        async handleSubmit() {
            this.submitLoading = true;
            await this.$store.dispatch('costable/duplicateTab', {
                tabId: this.tabId,
                name: this.name,
                description: this.description,
            });
            this.submitLoading = false;
            this.close();
        },
        open() {
            this.shown = true;
        },
        close() {
            this.shown = false;
        },
    },

};
</script>
